import toggle from '../../global/toggle';

function init(baseClass) {
    toggle({
        buttonClasses: {
            hookClass: 'js_careersPortalBenefitToggle',
        },
        targetClassesList: [
            {
                hookClass: 'js_careersPortalBenefit',
                toggleClass: 'careersPortalBenefit--show',
            },
        ],
    });
}

$(document).ready(init);
